import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from '@Components/Button';
import Loader from '@Components/Loader';
import ExportTabTooltip from './Components/ExportTabTooltip';

import './ExportTab.scss';

function ExportTab(props) {
  const { exportResult, closeTab, initializeTab, tooltipModalOpened, toggleTooltipModal } = props;

  useEffect(() => {
    initializeTab();

    return () => {
      closeTab();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTooltipToggle = () => {
    toggleTooltipModal(!tooltipModalOpened);
  };

  const handleTooltipClose = () => {
    toggleTooltipModal(false);
  };

  return (
    <div className={classnames('exportTab', { 'exportTab-hidden': !exportResult })}>
      {tooltipModalOpened && <ExportTabTooltip close={handleTooltipClose} {...props} />}
      {exportResult && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        <div className="exportTab__button" onClick={handleTooltipToggle}>
          <Button
            type="button"
            noBorder
            buttonConfig={{
              label: 'Exports',
              type: 'tertiary',
              size: 'sm',
              e2eName: 'export-tab-button',
              iconOnly: true,
            }}
          />
          <Loader className="exportTab__button_loader" showText={false} progressValue={exportResult.progress} />
        </div>
      )}
    </div>
  );
}

ExportTab.propTypes = {
  exportResult: PropTypes.object,
  closeTab: PropTypes.func.isRequired,
  initializeTab: PropTypes.func.isRequired,
  tooltipModalOpened: PropTypes.bool,
  toggleTooltipModal: PropTypes.func.isRequired,
};

export default ExportTab;
